export const login = (displayName, uid, userNamae, userUrl) => ({type: 'LOGIN', displayName, uid, userNamae, userUrl})
export const setAccessToken = (accessToken) => ({type: 'SET_ACCESS_TOKEN', accessToken})

export const setVocabularies = (vocabularies) => ({type: 'SET_VOCABULARIES', vocabularies})
export const setInputKeys = (inputKeys) => ({type: 'SET_INPUT_KEYS', inputKeys})
export const setSelectedContext = (selectedContext) => ({type: 'SET_SELECTED_CONTEXT', selectedContext})
export const setShowUploadModal = (showUploadModal, isMapping) => ({type: 'SHOW_UPLOAD_MODAL', showUploadModal, isMapping})
export const setAdvancedMode = (advancedMode) => ({type: 'SET_ADVANCED_MODE', advancedMode})
export const setContextsFromVocabularies = (contextsFromVocabularies) => ({type: 'SET_CONTEXTS_FROM_VOCABULARIES', contextsFromVocabularies})
export const setContextsFromGist = (contextsFromGist) => ({type: 'SET_CONTEXTS_FROM_GIST', contextsFromGist})
export const setVocabularyType = (keyName, keyType) => ({type: 'SET_VOCABULARY_TYPE', keyName, keyType})
export const setContents = (contents) => ({type: 'SET_CONTENTS', contents})
export const clearVocabularyType = (vocabularyType) => ({type: 'CLEAR_VOCABULARY_TYPE', vocabularyType})

export const setParsedContext = (parsedContext) => ({type: 'SET_PARSED_CONTEXT', parsedContext})
export const setContextByKey = (keyName, property, keyType) => ({type: 'SET_CONTEXT_BY_KEY', keyName, property, keyType})
export const removeContext = (keyName) => ({type: 'REMOVE_CONTEXT', keyName})
export const setContext = (mapped) => ({type: 'SET_CONTEXT', mapped})





// WEBPACK FOOTER //
// ./src/util/actions.js